import type { ComponentProps } from 'react';

import { Skeleton as ShadcnSkeleton } from '@/lib/shadcn/skeleton';
import { cn } from '@/lib/utils';

export function Skeleton({ className, ...props }: ComponentProps<typeof ShadcnSkeleton>) {
  return <ShadcnSkeleton className={cn('rounded-md', className)} {...props} />;
}
